import { Suspense, useEffect, useState } from "react";
import type { MantineThemeOverride } from "@mantine/core";
import "./styles/layers.css";
import "@mantine/core/styles.layer.css";
import "@xplatform/design-system/styles.layer.css";
import { LoadingScreen, XPlatformProvider } from "@xplatform/design-system";
import i18n, { I18N_NAMESPACE } from "@config/i18n";
import "./index.scss";
import { Routes, Route, Navigate } from "react-router-dom";
import { I18nextProvider } from "react-i18next";
import { injectStylesheet } from "@utils/injectStyles";
import { ModuleContextProvider } from "@src/ContextProvider";
import { ReviewsPage } from "@pages/ReviewsPage";

const PORTAL_ID = "dqm-portal-root";

const ModuleApp = () => {
  const [shellTheme, setShellTheme] =
    useState<MantineThemeOverride | undefined>(undefined);

  useEffect(() => {
    import("xplatform_shell/theme")
      .then((mod) => {
        if (mod.theme) setShellTheme(mod.theme);
      })
      .catch(() => {});
    const base = import.meta.env.BASE_URL || "/";
    injectStylesheet(`${base}assets/style.css`);
  }, []);

  return (
    <I18nextProvider i18n={i18n} defaultNS={I18N_NAMESPACE}>
      <XPlatformProvider theme={shellTheme}>
        <ModuleContextProvider>
          <Suspense fallback={<LoadingScreen message="Loading..." />}>
            <Routes>
              <Route index element={<Navigate to="reviews" replace />} />
              <Route path="reviews/*" element={<ReviewsPage />} />
              <Route path="*" element={<Navigate to="reviews" replace />} />
            </Routes>
          </Suspense>
        </ModuleContextProvider>
        <div
          id={PORTAL_ID}
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            pointerEvents: "none",
            zIndex: 9999,
          }}
        />
      </XPlatformProvider>
    </I18nextProvider>
  );
};

export default ModuleApp;
